var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.creativeId !== 'add')?_c('creativePage'):_vm._e(),(_vm.$route.params.creativeId === 'add')?_c('addCreativesPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }